export default __webpack_public_path__ + "static/media/stadistics.caaf091f.svg";